export const SET_APP_NAME = 'set-app-name';

const setAppName = ({ name }) => ({ type: SET_APP_NAME, payload: { name } });
export default setAppName;
